import React from 'react'
import { connect } from 'react-redux'
import {
    getIssueLogs,
    updateIssueLog,
    getAllIssueLogsFromServer,
} from 'src/store/modules/runbooks'
import * as BP from '@blueprintjs/core'
import {
    ISSUELOG_SEVERITIES,
    ISSUELOG_PRIORITIES,
    ISSUELOG_STATUSES,
} from 'src/constants/issueLogs'
import AddIssueDialog from 'src/routes/Runbook/Controls/Dialogs/AddIssueDialog'
import { bindActionCreators } from 'redux'
import { Flex, Box } from 'reflexbox'

import './style.scss'

const classNamePrefix = 'runbooks-issue-logs'

class IssueLogs extends React.Component {
    state = {
        editingLog: null,
    }
    componentDidMount() {
        this.props.actions.getAllIssueLogsFromServer(this.props.session)
    }
    handleEditIssueClick(log) {
        this.setState({ editingLog: log })
    }
    handleEditIssueClose(log) {
        this.setState({ editingLog: null })
    }
    renderIssueLogs() {
        return this.props.issueLogs.map((log) => (
            <BP.Card key={log.id} interactive elevation={BP.Elevation.TWO}>
                <Flex>
                    <Box w={1 / 5}>
                        <div className={`${classNamePrefix}_tag-container`}>
                            <span className="uid">
                                {log.action ? (
                                    <BP.Tag>{log.action.uid}</BP.Tag>
                                ) : null}
                            </span>
                            <span className="action-name">
                                {log.action ? (
                                    <BP.Tag intent={log.action ? 'danger' : ''}>
                                        {log.action.name}
                                    </BP.Tag>
                                ) : null}
                            </span>
                        </div>
                    </Box>
                    <Box w={3 / 5}>
                        <div className={`${classNamePrefix}_content-container`}>
                            <Flex justify="space-between">
                                <Box w={2 / 12}>
                                    <span
                                        className={`${classNamePrefix}_field`}
                                    >
                                        <span
                                            className={`${classNamePrefix}_field-label`}
                                        >
                                            Owner:
                                        </span>
                                        {log.owner}
                                    </span>
                                </Box>
                                <Box w={1 / 12}>
                                    <span
                                        className={`${classNamePrefix}_field`}
                                    >
                                        <span
                                            className={`${classNamePrefix}_field-label`}
                                        >
                                            Status:
                                        </span>
                                        {
                                            this.props.statusChoices.find(
                                                (choice) =>
                                                    choice[0] === log.status
                                            )[1]
                                        }
                                    </span>
                                </Box>
                                <Box w={1 / 12}>
                                    <span
                                        className={`${classNamePrefix}_field`}
                                    >
                                        <span
                                            className={`${classNamePrefix}_field-label`}
                                        >
                                            Severity:
                                        </span>
                                        {
                                            this.props.severityChoices.find(
                                                (choice) =>
                                                    choice[0] === log.severity
                                            )[1]
                                        }
                                    </span>
                                </Box>
                                <Box w={1 / 12}>
                                    <span
                                        className={`${classNamePrefix}_field`}
                                    >
                                        <span
                                            className={`${classNamePrefix}_field-label`}
                                        >
                                            Priority:
                                        </span>
                                        {
                                            this.props.priorityChoices.find(
                                                (choice) =>
                                                    choice[0] === log.priority
                                            )[1]
                                        }
                                    </span>
                                </Box>
                                <Box w={4 / 12}>
                                    <span
                                        className={`${classNamePrefix}_field`}
                                    >
                                        <span
                                            className={`${classNamePrefix}_field-label`}
                                        >
                                            Description:
                                        </span>
                                        {log.description}
                                    </span>
                                </Box>
                                <Box w={3 / 12}>
                                    <span
                                        className={`${classNamePrefix}_field`}
                                    >
                                        <span
                                            className={`${classNamePrefix}_field-label`}
                                        >
                                            Solution:
                                        </span>
                                        {log.solution}
                                    </span>
                                </Box>
                            </Flex>
                        </div>
                    </Box>
                    <Box w={1 / 5} style={{ textAlign: 'right' }}>
                        <span className="created-at">{log.createdAt}</span>
                        <BP.Button
                            style={{ margin: 'auto 0 auto 0' }}
                            icon="edit"
                            onClick={() => {
                                this.handleEditIssueClick(log)
                            }}
                        />
                    </Box>
                </Flex>
            </BP.Card>
        ))
    }
    renderAddIssueDialog() {
        let {
            id,
            owner,
            description,
            issue,
            action,
            status,
            severity,
            priority,
            due,
            solution,
        } = this.state.editingLog
        return (
            <AddIssueDialog
                id={id}
                owner={owner}
                description={description}
                priority={priority}
                severity={severity}
                status={status}
                issue={issue}
                due={due}
                solution={solution}
                fromAction={(action && action.uid) || null}
                handleConfirm={(data) => {
                    this.props.actions.updateIssueLog(this.props.session, data)
                }}
                handleClose={(data) => {
                    this.handleEditIssueClose()
                }}
            />
        )
    }

    render() {
        if (!this.props.issueLogs) return null
        let issueLogs = this.renderIssueLogs()
        let addIssueDialog = this.state.editingLog
            ? this.renderAddIssueDialog()
            : null
        return (
            <div className={classNamePrefix}>
                {issueLogs}
                {addIssueDialog}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    issueLogs: getIssueLogs(state),
    isEditingIssue: state.ui.runbook.controls.isInsertingIssue,
    priorityChoices: state.app.issueLogPriorities ?? ISSUELOG_PRIORITIES,
    severityChoices: state.app.issueLogSeverities ?? ISSUELOG_SEVERITIES,
    statusChoices: state.app.issueLogStatuses ?? ISSUELOG_STATUSES,
})

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        dispatch,
        actions: bindActionCreators(
            {
                updateIssueLog,
                getAllIssueLogsFromServer,
            },
            dispatch
        ),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueLogs)
